import type { Step } from "react-joyride";

export const meetingFormEditTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ແກ້ໄຂບັນທຶກການປະຊຸມ. ປັບວັນທີ, ຫົວຂໍ້, ສະຫຼຸບ, ຜູ້ຮ່ວມ ແລະ ປະເດັນທີ່ລົມກັນ.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="meeting-form-edit-back"]',
    content:
      "ກັບຄືນໄປຫນ້າລາຍລະອຽດບັນທຶກການປະຊຸມ. ກົດປຸ່ມ ? ເພື່ອເລີ່ມທົດສອບການນຳທາງ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="meeting-form-form"]',
    content:
      "ແບບຟອມແກ້ໄຂ: ປັບຂໍ້ມູນຕາມຕ້ອງການ ແລະ ກົດບັນທຶກເພື່ອອັບເດດ.",
    placement: "top",
  },
];
